export default "__VITE_ASSET__DQiTn8lu__"